export default "__VITE_ASSET__DUmeF3hO__"